import React from 'react';
import { useEffect } from 'react';
import useAnalytics from './main';
import AnalyticsProvider from './components/AnalyticsProvider';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopOnNavigate from './components/ScrollToTopOnNavigate';
import Home from './pages/Home';
import Services from './pages/Services';
import Support from './pages/Support';
import Contact from './pages/Contact';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import UeberMich from './pages/UeberMich';
import Referenzen from './pages/Referenzen';
import Wissen from './pages/Wissen';
import Microsoft365Optimierung from './pages/Microsoft365Optimierung';
import DigitalisierungProzessoptimierung from './pages/DigitalisierungProzessoptimierung';
import ITInfrastrukturKMU from './pages/ITInfrastrukturKMU';
import ITSicherheitISMS from './pages/ITSicherheitISMS';
import ITAdministrator from './pages/ITAdministrator';
import ITLeiter from './pages/ITLeiter';
import ITBereichsleiter from './pages/ITBereichsleiter';
import InterimsITLeiter from './pages/InterimsITLeiter';
import InterimsITAdministrator from './pages/InterimsITAdministrator';
import WebseitenErstellung from './pages/WebseitenErstellung';
import VirtualisierungLinux from './pages/VirtualisierungLinux';
import LinuxAdministration from './pages/LinuxAdministration';
import "./App.css";

function App() {
  useEffect(() => {
  const consent = localStorage.getItem('cookieConsent');
  const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (consent === 'accepted' && measurementId) {
    //initGA(measurementId);
    //logPageView();    
    //useAnalytics();
    //alert('Google Analytics initialized');

  }
}, []);


  // useEffect(() => {
  //  initGA();
  //}, []);
  
  // useEffect(() => {
  //   logPageView();
  // }, [location]);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTopOnNavigate />
        <AnalyticsProvider />
        <Header />
        <main className="flex-1 w-full">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ueber-mich" element={<UeberMich />} />
            <Route path="/services" element={<Services />} />
            <Route path="/microsoft-365-optimierung" element={<Microsoft365Optimierung />} />
            <Route path="/digitalisierung-prozessoptimierung" element={<DigitalisierungProzessoptimierung />} />
            <Route path="/it-infrastruktur-kmu" element={<ITInfrastrukturKMU />} />
            <Route path="/it-sicherheit-isms" element={<ITSicherheitISMS />} />
            <Route path="/virtualisierung-linux" element={<VirtualisierungLinux />} />
            <Route path="/support" element={<Support />} />
            <Route path="/referenzen" element={<Referenzen />} />
            <Route path="/wissen" element={<Wissen />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            {/* SEO Landing Pages */}
            <Route path="/it-administrator-moenchengladbach" element={<ITAdministrator />} />
            <Route path="/it-leiter-kmu" element={<ITLeiter />} />
            <Route path="/it-bereichsleiter" element={<ITBereichsleiter />} />
            <Route path="/interims-it-leiter" element={<InterimsITLeiter />} />
            <Route path="/interims-it-administrator" element={<InterimsITAdministrator />} />
            <Route path="/webseiten-erstellung-moenchengladbach" element={<WebseitenErstellung />} />
            <Route path="/linux-administration-moenchengladbach" element={<LinuxAdministration />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop />
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;